// For accessing router paths throughout the app. See routes for full routes.
export default {
  timeIn: 'time',
  day6: 'character'
}
